import React from "react";


export const Footer = ()=>{
    
    
   return (
    <footer className="bg-dark text-light  mt-5 p-3">
       
       <p className="text-center fs-4 ">&copy; Code Heads hub Loyalty Program</p>
      
    </footer>
   )
}